<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    晒布站<br>
站点介绍<br>
晒布站位于东门中路与晒布路交汇处，沿东门中路呈东西走向。车站地处繁华的购物天堂东门附近，车站东北侧为东门布匹市场、深圳中学、儿童公园，西北侧为人民公园，西侧为深圳迎宾馆、南海中心，西南侧紧邻茂业百货、天虹商场、女人世界、东门商业区。晒布站以白色及浅棕色为主色调。四周墙壁采用白色搪瓷钢板，站厅、站台中间立柱采用浅棕色搪瓷钢板。站台立柱上方贴有纺织类壁纸，以突出车站所在区域的历史文化气息，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:15	23:49	3号线	2分15-20秒	4分30秒<br>
双龙	06:00	23:24	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:24	23:49	3号线	3分15秒	5分钟<br>
双龙	06:09	23:23	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:24	00:49	3号线	3分15秒	5分钟<br>
双龙	06:09	00:23	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
东门中路南侧（东）、兴湖路南侧、东门步行街(东)、湖贝菜市场、湖贝路、东门金融大厦<br><br>
A2出入口:<br>
东门中心城<br><br>
A3出入口:<br>
东门中路、东门中心城（西）<br><br>
B出入口:<br>
东门中路北侧(东)、兴湖路北侧、中兴路、湖贝村、东升路<br><br>
C出入口:<br>
东门中路北侧(西)、童乐路、深圳儿童公园、华盛.君荟名庭（修改）、深中布料批发市场、深中街<br><br>
D1出入口:<br>
红桂路、深圳小学、深圳中学、深圳市红十字会、人民小学、人民公园、东门天地大厦<br><br>
D3出入口:<br>
东门中路南侧（西）、东门步行街(西)、南海中心、立新路、罗湖社康、深圳非凡医疗美容医院、新园路、建设银行、工人文化宫<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 东门④<br>
211路,M399路,M482路<br><br>
A1出入口:<br>
公交站名： 东门③<br>
1路,113路,369路,M239路,M402路,M509路,N7路(高快巴士20路<br><br>
A3出入口:<br>
公交站名： 东门⑤<br>
5路，69路，103路，203路，M559路<br><br>
A3出入口:<br>
公交站名： 东门⑥<br>
M207路,M404路,M407路,M408路<br><br>
B出入口:<br>
公交站名： 东门中①<br>
1路,3路(,11路(,306路,369路,M402路，M403路,M482路，M508路,N3路,N7路<br><br>
C出入口:<br>
公交站名： 东门中①<br>
3路,306路,369路,M402路,M403路,M482路,M508路,N3路<br><br>
C出入口:<br>
公交站名： 东门⑥<br>
M207路，M404路，M407路，M408路<br><br>
D1出入口:<br>
公交站名： 东门⑤<br>
5路，103路，203路，M399路，M559路<br><br>
D3出入口:<br>
公交站名： 东门③<br>
1路,113路,211路,M239路,M402路,M509路,N7路,高快巴士20路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>